import type { ReactNode } from 'react';
import { useGetToPath, useResourceParams } from '@refinedev/core';
import type { BaseKey } from '@refinedev/core';
import { Link } from 'react-router-dom';

export type ShowLinkProps = {
  resource: string;
  id: BaseKey;
  /** Open in a new tab — for links shown mid-flow, where navigating away
   * would abandon work in progress. */
  newTab?: boolean;
  children?: ReactNode;
};

export const ShowLink = ({ resource, id, newTab, children }: ShowLinkProps) => {
  const getToPath = useGetToPath();
  const { resource: resourceItem } = useResourceParams({ resource });
  const to = getToPath({
    resource: resourceItem,
    action: 'show',
    meta: { id },
  });
  const content = children ?? id;
  if (!to) return <>{content}</>;
  return (
    <Link to={to} {...(newTab ? { target: '_blank', rel: 'noopener' } : {})}>
      {content}
    </Link>
  );
};
